import _ from 'lodash'

export default class ActivityArea {
    constructor(paths, data = {}){
        this._activityArea = new google.maps.Polygon({
            ...data,
            paths,
            clickable: false
        })
    }
    setMap(map){
        this._activityArea.setMap(map)
    }
    get() {
        return this._activityArea
    }
}